/* Footer image stage — the reference's deck mechanic:
   - hovering the Site index list wipes the 4:5 stage open top-down;
     leaving collapses it to the bottom edge (same clip-path family as the
     hero/menu wipes)
   - each link hover appends a fresh layer that slides down from above while
     its image slides up from below (inner parallax), landing over the
     previous one; layers are capped so the deck can't grow unbounded
   Desktop + fine pointer only, evaluated live so resize/rotate re-decides.
   Registry-managed: the footer is inside the Barba container, so this re-runs
   after every swap; listeners carry the page's abort signal. */
(function () {
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var WIPE_MS = 600;
  var FULL = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
  var TOP_EDGE = 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)';
  var BOTTOM_EDGE = 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)';

  var media = window.matchMedia('(min-width: 992px) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function active() {
    return media.matches && !reduceMotion.matches;
  }

  function init(ctx) {
  var signal = ctx && ctx.signal;
  var stage = document.querySelector('[data-footer-stage]');
  var wrap = document.querySelector('[data-footer-triggers]');

  /* easter egg — hovering the big mark flips the hidden page on (instant
     toggle, exactly like the reference); the overlay is pointer-events: none
     so the hover never breaks */
  var easter = document.querySelector('[data-footer-easter]');
  var easterTrigger = document.querySelector('[data-footer-easter-trigger]');
  if (easter && easterTrigger) {
    easterTrigger.addEventListener('mouseenter', function () {
      if (media.matches) easter.classList.add('is-on');
    }, { signal: signal });
    easterTrigger.addEventListener('mouseleave', function () {
      easter.classList.remove('is-on');
    }, { signal: signal });
  }

  if (!stage || !wrap) return;

  wrap.addEventListener('mouseenter', function () {
    if (!active()) return;
    stage.animate(
      [{ clipPath: TOP_EDGE }, { clipPath: FULL }],
      { duration: WIPE_MS, easing: EASE, fill: 'forwards' }
    );
  }, { signal: signal });

  wrap.addEventListener('mouseleave', function () {
    if (!active()) return;
    stage.animate(
      [{ clipPath: FULL }, { clipPath: BOTTOM_EDGE }],
      { duration: WIPE_MS, easing: EASE, fill: 'forwards' }
    );
  }, { signal: signal });

  wrap.querySelectorAll('[data-footer-trigger]').forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      if (!active()) return;

      var layer = document.createElement('div');
      var media_el;
      if (link.dataset.img) {
        media_el = document.createElement('img');
        media_el.src = link.dataset.img;
        media_el.alt = '';
      } else {
        media_el = document.createElement('span');
        media_el.className = 'onni-footer_stage-ph onni-footer_stage-ph--' + (link.dataset.ph || '1');
      }
      layer.appendChild(media_el);
      stage.appendChild(layer);

      layer.animate(
        [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }],
        { duration: WIPE_MS, easing: EASE, fill: 'forwards' }
      );
      media_el.animate(
        [{ transform: 'translateY(90%)' }, { transform: 'translateY(0)' }],
        { duration: WIPE_MS, easing: EASE, fill: 'forwards' }
      );

      while (stage.children.length > 12) {
        stage.removeChild(stage.firstChild);
      }
    }, { signal: signal });
  });
  }

  if (window.Onni && window.Onni.register) {
    window.Onni.register('footer', init);
  } else {
    init();
  }
})();
